if($('.type-posts-listing').length){
    $('.news-item').each(function(){
        $(this).find('.description').after('<div class="text-right"><span class="name">Vojtěch Jiříček</span><a href="'+$(this).find('a.title').attr('href')+'">Celý článek</a></div>')
    });
}